module.exports = "/img/More-3.cf4375a8.png";